import { render, staticRenderFns } from "./ChoroMap.vue?vue&type=template&id=059f114d&scoped=true"
import script from "./ChoroMap.vue?vue&type=script&lang=js"
export * from "./ChoroMap.vue?vue&type=script&lang=js"
import style0 from "./ChoroMap.vue?vue&type=style&index=0&id=059f114d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f114d",
  null
  
)

export default component.exports